const showModal = ref(false)

watch(showModal, () => {
  document.body.style.overflowY = showModal.value ? 'hidden' : 'auto'
})

export const useModal = () => {
  const changeShowModal = (value = !showModal.value) => {
    showModal.value = value
  }

  return { showModal, changeShowModal }
}